import { render } from "./AddConfigurationForm.vue?vue&type=template&id=3d4ce7de"
import script from "./AddConfigurationForm.vue?vue&type=script&lang=js"
export * from "./AddConfigurationForm.vue?vue&type=script&lang=js"
script.render = render

export default script